export class MemberPointsBalanceContainerConfigurationPropsApi {
    /**
     * If toggled on, the point balance container will display on the “Account Offers Rewards” page, which will display the member’s spending point balance in a unique container and tile.
     */
    displayPointBalanceContainer: boolean

    pointsBalanceContainerTitle: string = 'Food and beverage credit'

    /**
     * Description displayed within the container if the member has no points in their spending point balance.
     */
    pointsBalanceContainerNoPointsDescription: string

    /**
     * Description displayed within the container if the member has points in their spending point balance.
     */
    pointsBalanceContainerPointsDescription: string

    pointsBalanceTileTitle: string = 'Food and beverage credit'

    /**
     * Supports the soonest expiry date of points in the member’s spending point balance as a variable.
     */
    pointsBalanceTileExpiryMessage: string = 'Expires ${expiryDate|d|MMMM D, YYYY}'

    /**
     * Supports the total monetary value of the member’s spending point balance as a variable.
     */
    pointsBalanceTileRemainingCredit: string = '${monetaryValue|c} remaining'
}
